import React from 'react';
import PropTypes from 'prop-types';

// Assets
import mediumNoImage from '/public/SiteImages/medium_no_image.png';
import largeNoImage from '/public/SiteImages/large_no_image.jpeg';

// components
import LazyLoadImage from '../LazyLoadImage';

class ListCoverPhoto extends React.Component {
    static propTypes = {
        coverPhoto: PropTypes.number,
        listPhotos: PropTypes.array,
        className: PropTypes.string,
        bgImage: PropTypes.bool
    };

    static defaultProps = {
        bgImage: false,
        lazyLoad: false
    }

    constructor(props) {
        super(props);
        this.state = {
            activePhoto: null
        };
    }

    getImageSource = (photo, size = 'x_medium_') => {
        if (photo?.source === 'UploadCare') {
            return `https://ucarecdn.com/${photo?.name}/`;
        } else {
            return `/images/upload/${size}${photo?.name}`;
        }
    };

    UNSAFE_componentWillMount() {
        const { coverPhoto, listPhotos } = this.props;
        if (listPhotos != undefined && listPhotos.length > 0) {
            let activePhoto = listPhotos[0];
            if (coverPhoto != undefined && coverPhoto != null) {
                const cover = listPhotos.find((item) => item.id === coverPhoto);
                if (cover) activePhoto = cover;
            }
            this.setState({ activePhoto });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { coverPhoto, listPhotos } = nextProps;
        if (listPhotos != undefined && listPhotos.length > 0) {
            let activePhoto = listPhotos[0];
            if (coverPhoto != undefined && coverPhoto != null) {
                const cover = listPhotos.find((item) => item.id === coverPhoto);
                if (cover) activePhoto = cover;
            }
            this.setState({ activePhoto });
        }
    }

    render() {
        const { className, photoType, bgImage, lazyLoad, placeholderClassName } = this.props;
        const { activePhoto } = this.state;
        let source;

        if (activePhoto != null) {
            source = this.getImageSource(activePhoto, photoType ? 'x_medium_' : '');
        } else {
            if (photoType === "x_medium") {
                source = largeNoImage;
            } else if (photoType === "x_small") {
                source = mediumNoImage;
            } else {
                source = mediumNoImage;
            }
        }

        if (lazyLoad && bgImage) {
            return (
                <LazyLoadImage
                    src={source}
                    placeholderSrc={activePhoto?.source === 'UploadCare' ? source : `/images/upload/placeholder_${activePhoto?.name}`}
                    className={className}
                    placeholderClassName={placeholderClassName}
                />
            );
        } else if (bgImage) {
            return (
                <div className={className} style={{ backgroundImage: `url(${source})` }}>
                    {this.props.children}
                </div>
            );
        } else {
            return (
                <div className={className} style={{ backgroundImage: `url(${source})` }} />
            );
        }
    }
}

export default ListCoverPhoto;